import { render, staticRenderFns } from "./TermTree.vue?vue&type=template&id=293099cb&scoped=true&"
import script from "./TermTree.vue?vue&type=script&lang=ts&"
export * from "./TermTree.vue?vue&type=script&lang=ts&"
import style0 from "./TermTree.vue?vue&type=style&index=0&id=293099cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293099cb",
  null
  
)

export default component.exports